// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/mlinference/v1/ml_inference.proto" (package "viam.app.mlinference.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { MLInferenceService } from "./ml_inference";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GetInferenceResponse } from "./ml_inference";
import type { GetInferenceRequest } from "./ml_inference";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service viam.app.mlinference.v1.MLInferenceService
 */
export interface IMLInferenceServiceClient {
    /**
     * @generated from protobuf rpc: GetInference(viam.app.mlinference.v1.GetInferenceRequest) returns (viam.app.mlinference.v1.GetInferenceResponse);
     */
    getInference(input: GetInferenceRequest, options?: RpcOptions): UnaryCall<GetInferenceRequest, GetInferenceResponse>;
}
/**
 * @generated from protobuf service viam.app.mlinference.v1.MLInferenceService
 */
export class MLInferenceServiceClient implements IMLInferenceServiceClient, ServiceInfo {
    typeName = MLInferenceService.typeName;
    methods = MLInferenceService.methods;
    options = MLInferenceService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetInference(viam.app.mlinference.v1.GetInferenceRequest) returns (viam.app.mlinference.v1.GetInferenceResponse);
     */
    getInference(input: GetInferenceRequest, options?: RpcOptions): UnaryCall<GetInferenceRequest, GetInferenceResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetInferenceRequest, GetInferenceResponse>("unary", this._transport, method, opt, input);
    }
}
